<template>
  <router-view />
</template>

<script>

export default {
  name: 'ProductWrapper'
}
</script>
